import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, apiError } from "@/lib/api";

const NONE = "__none__";

export const GroupAssign = ({ charge, onSaved }) => {
  const [groups, setGroups] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/groups").then((r) => setGroups(r.data)); }, []);

  const change = async (v) => {
    setSaving(true);
    try {
      const { data } = await api.patch(`/charges/${charge.id}/group`, { group_id: v === NONE ? null : v });
      onSaved(data);
      toast.success(v === NONE ? "Grupo quitado del cobro" : "Grupo asignado al cobro");
    } catch (e) { toast.error(apiError(e).message); } finally { setSaving(false); }
  };

  return (
    <div className="flex items-center justify-between gap-4 border-b border-slate-100 py-3" data-testid="detail-group-assign">
      <span className="text-sm text-slate-500">Grupo{!charge.group_id && <span className="ml-2 rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700 ring-1 ring-amber-200" data-testid="detail-group-missing">Sin asignar</span>}</span>
      <Select value={charge.group_id || NONE} onValueChange={change} disabled={saving}>
        <SelectTrigger className="h-9 w-56" data-testid="detail-group-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE} data-testid="detail-group-option-none">Sin grupo</SelectItem>
          {groups.map((g) => <SelectItem key={g.id} value={g.id} data-testid={`detail-group-option-${g.id}`}>{g.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};
